import { render } from "./FooterContactsPage.vue?vue&type=template&id=119a3870&scoped=true"
const script = {}

import "./FooterContactsPage.vue?vue&type=style&index=0&id=119a3870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119a3870"]])

export default __exports__